import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbTooltipConfig } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Observer } from "rxjs";

export const RADIO_BUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ToggleSwitchComponent),
  multi: true
};

@Component({
  selector: '[toggle-switch]',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.css'],
  providers: [RADIO_BUTTON_VALUE_ACCESSOR, NgbTooltipConfig]
})
export class ToggleSwitchComponent implements ControlValueAccessor, OnInit {
  @Input() objectReference: boolean = false;
  @Input() mandatory: boolean;
  @Input() labelInput: string;
  @Input() submitPending: boolean;
  @Output() onReturn = new EventEmitter();
  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };
  private _value: any;
  public enableObservable: Observable < boolean >;
  private enableObserver: Observer < boolean > ;
  constructor() { }

  private createServiceSubscription() {
    this.enableObservable = new Observable < boolean > (observer => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

}
